<div class="section-container">
  @if (recentSearches && recentSearches.length > 0) {
    <div
      class="chip-container"
      >
      <div class="chip-header">
        <div class="icon-co">
          <img src="/images/icons/clock-icon.svg" alt="clock " />
        </div>
        <h4 class="chip-title">Recent Searches</h4>
      </div>
      <div class="chip-main">
        <mat-chip-listbox aria-label="Recent Searches">
          @for (item of recentSearches; track item) {
            <mat-chip-option
              [removable]="true"
              (removed)="removeRecentlySearchedItem(item)"
              (click)="goToQuery(item)"
              class="outline-chip search-suggestion-chip"
              >
              {{ item }}
              <img matChipRemove src="/images/icons/close-icon.svg" alt="remove recent search item" />
              <!-- <button matChipRemove class="remove-icon">
                <div class="icon-co">
                </div>
              </button> -->
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>
    </div>
  }

  @if (trendingSearches && trendingSearches.length > 0) {
    <div
      class="chip-container"
      >
      <div class="chip-header">
        <div class="icon-co">
          <img src="/images/icons/flame.svg" alt="flame" />
        </div>
        <h4 class="chip-title">Trending Searches</h4>
      </div>
      @if (trendingSearches && trendingSearches.length > 0) {
        <div
          class="chip-main"
          >
          <mat-chip-listbox aria-label="Trending Searches">
            @for (item of trendingSearches; track item) {
              <mat-chip-option
                class="outline-chip search-suggestion-chip"
                (click)="goToQuery(item)"
                >
                {{ item }}
              </mat-chip-option>
            }
          </mat-chip-listbox>
        </div>
      }
    </div>
  }
</div>